import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {Material} from "../types/Material";

const emptyArray: Material[] = [];

export const useGetMaterials = (dealerID: number, zipCode: string, enabled: boolean) => {
    const {data, isLoading} = useQuery({
        queryKey: ['ee-tool-materials', dealerID, zipCode],
        enabled: dealerID > 0 && enabled,
        queryFn: async () => await apiClient.get('ee-tool/materials?dealerID=' + dealerID + '&zipCode=' + zipCode) as Material[]
    });

    return {
        data: data || emptyArray,
        isLoading: isLoading
    };
};
